/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './modules/routing/routes/__root'
import { Route as GocardlessCallbackRouteImport } from './modules/routing/routes/gocardless-callback'
import { Route as AboutRouteImport } from './modules/routing/routes/about'
import { Route as AuthenticatedRouteImport } from './modules/routing/routes/_authenticated'
import { Route as DashboardRouteRouteImport } from './modules/routing/routes/dashboard/route'
import { Route as IndexRouteImport } from './modules/routing/routes/index'
import { Route as OnboardingIndexRouteImport } from './modules/routing/routes/onboarding/index'
import { Route as DashboardIndexRouteImport } from './modules/routing/routes/dashboard/index'
import { Route as AuthIndexRouteImport } from './modules/routing/routes/auth/index'
import { Route as AuthSigninRouteImport } from './modules/routing/routes/auth/signin'
import { Route as AuthRegisterRouteImport } from './modules/routing/routes/auth/register'
import { Route as DashboardTransactionsIndexRouteImport } from './modules/routing/routes/dashboard/transactions/index'
import { Route as DashboardRulesIndexRouteImport } from './modules/routing/routes/dashboard/rules/index'
import { Route as DashboardReportsIndexRouteImport } from './modules/routing/routes/dashboard/reports/index'
import { Route as DashboardInsightsIndexRouteImport } from './modules/routing/routes/dashboard/insights/index'
import { Route as DashboardBudgetsIndexRouteImport } from './modules/routing/routes/dashboard/budgets/index'
import { Route as DashboardAccountsIndexRouteImport } from './modules/routing/routes/dashboard/accounts/index'
import { Route as DashboardTransactionsIdRouteImport } from './modules/routing/routes/dashboard/transactions/$id'
import { Route as DashboardReportsReportIdRouteImport } from './modules/routing/routes/dashboard/reports/$reportId'
import { Route as DashboardCategoriesCategoryIdRouteImport } from './modules/routing/routes/dashboard/categories/$categoryId'

const GocardlessCallbackRoute = GocardlessCallbackRouteImport.update({
  id: '/gocardless-callback',
  path: '/gocardless-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/onboarding/',
  path: '/onboarding/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/auth/',
  path: '/auth/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSigninRoute = AuthSigninRouteImport.update({
  id: '/auth/signin',
  path: '/auth/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/auth/register',
  path: '/auth/register',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardTransactionsIndexRoute =
  DashboardTransactionsIndexRouteImport.update({
    id: '/transactions/',
    path: '/transactions/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardRulesIndexRoute = DashboardRulesIndexRouteImport.update({
  id: '/rules/',
  path: '/rules/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardReportsIndexRoute = DashboardReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardInsightsIndexRoute = DashboardInsightsIndexRouteImport.update({
  id: '/insights/',
  path: '/insights/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardBudgetsIndexRoute = DashboardBudgetsIndexRouteImport.update({
  id: '/budgets/',
  path: '/budgets/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardAccountsIndexRoute = DashboardAccountsIndexRouteImport.update({
  id: '/accounts/',
  path: '/accounts/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardTransactionsIdRoute = DashboardTransactionsIdRouteImport.update({
  id: '/transactions/$id',
  path: '/transactions/$id',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardReportsReportIdRoute =
  DashboardReportsReportIdRouteImport.update({
    id: '/reports/$reportId',
    path: '/reports/$reportId',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardCategoriesCategoryIdRoute =
  DashboardCategoriesCategoryIdRouteImport.update({
    id: '/categories/$categoryId',
    path: '/categories/$categoryId',
    getParentRoute: () => DashboardRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/gocardless-callback': typeof GocardlessCallbackRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth': typeof AuthIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/onboarding': typeof OnboardingIndexRoute
  '/dashboard/categories/$categoryId': typeof DashboardCategoriesCategoryIdRoute
  '/dashboard/reports/$reportId': typeof DashboardReportsReportIdRoute
  '/dashboard/transactions/$id': typeof DashboardTransactionsIdRoute
  '/dashboard/accounts': typeof DashboardAccountsIndexRoute
  '/dashboard/budgets': typeof DashboardBudgetsIndexRoute
  '/dashboard/insights': typeof DashboardInsightsIndexRoute
  '/dashboard/reports': typeof DashboardReportsIndexRoute
  '/dashboard/rules': typeof DashboardRulesIndexRoute
  '/dashboard/transactions': typeof DashboardTransactionsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/gocardless-callback': typeof GocardlessCallbackRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth': typeof AuthIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/onboarding': typeof OnboardingIndexRoute
  '/dashboard/categories/$categoryId': typeof DashboardCategoriesCategoryIdRoute
  '/dashboard/reports/$reportId': typeof DashboardReportsReportIdRoute
  '/dashboard/transactions/$id': typeof DashboardTransactionsIdRoute
  '/dashboard/accounts': typeof DashboardAccountsIndexRoute
  '/dashboard/budgets': typeof DashboardBudgetsIndexRoute
  '/dashboard/insights': typeof DashboardInsightsIndexRoute
  '/dashboard/reports': typeof DashboardReportsIndexRoute
  '/dashboard/rules': typeof DashboardRulesIndexRoute
  '/dashboard/transactions': typeof DashboardTransactionsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/_authenticated': typeof AuthenticatedRoute
  '/about': typeof AboutRoute
  '/gocardless-callback': typeof GocardlessCallbackRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/': typeof AuthIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/dashboard/categories/$categoryId': typeof DashboardCategoriesCategoryIdRoute
  '/dashboard/reports/$reportId': typeof DashboardReportsReportIdRoute
  '/dashboard/transactions/$id': typeof DashboardTransactionsIdRoute
  '/dashboard/accounts/': typeof DashboardAccountsIndexRoute
  '/dashboard/budgets/': typeof DashboardBudgetsIndexRoute
  '/dashboard/insights/': typeof DashboardInsightsIndexRoute
  '/dashboard/reports/': typeof DashboardReportsIndexRoute
  '/dashboard/rules/': typeof DashboardRulesIndexRoute
  '/dashboard/transactions/': typeof DashboardTransactionsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/about'
    | '/gocardless-callback'
    | '/auth/register'
    | '/auth/signin'
    | '/auth'
    | '/dashboard/'
    | '/onboarding'
    | '/dashboard/categories/$categoryId'
    | '/dashboard/reports/$reportId'
    | '/dashboard/transactions/$id'
    | '/dashboard/accounts'
    | '/dashboard/budgets'
    | '/dashboard/insights'
    | '/dashboard/reports'
    | '/dashboard/rules'
    | '/dashboard/transactions'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/gocardless-callback'
    | '/auth/register'
    | '/auth/signin'
    | '/auth'
    | '/dashboard'
    | '/onboarding'
    | '/dashboard/categories/$categoryId'
    | '/dashboard/reports/$reportId'
    | '/dashboard/transactions/$id'
    | '/dashboard/accounts'
    | '/dashboard/budgets'
    | '/dashboard/insights'
    | '/dashboard/reports'
    | '/dashboard/rules'
    | '/dashboard/transactions'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/_authenticated'
    | '/about'
    | '/gocardless-callback'
    | '/auth/register'
    | '/auth/signin'
    | '/auth/'
    | '/dashboard/'
    | '/onboarding/'
    | '/dashboard/categories/$categoryId'
    | '/dashboard/reports/$reportId'
    | '/dashboard/transactions/$id'
    | '/dashboard/accounts/'
    | '/dashboard/budgets/'
    | '/dashboard/insights/'
    | '/dashboard/reports/'
    | '/dashboard/rules/'
    | '/dashboard/transactions/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  AuthenticatedRoute: typeof AuthenticatedRoute
  AboutRoute: typeof AboutRoute
  GocardlessCallbackRoute: typeof GocardlessCallbackRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthSigninRoute: typeof AuthSigninRoute
  AuthIndexRoute: typeof AuthIndexRoute
  OnboardingIndexRoute: typeof OnboardingIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/gocardless-callback': {
      id: '/gocardless-callback'
      path: '/gocardless-callback'
      fullPath: '/gocardless-callback'
      preLoaderRoute: typeof GocardlessCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/': {
      id: '/onboarding/'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/auth/': {
      id: '/auth/'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signin': {
      id: '/auth/signin'
      path: '/auth/signin'
      fullPath: '/auth/signin'
      preLoaderRoute: typeof AuthSigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/register': {
      id: '/auth/register'
      path: '/auth/register'
      fullPath: '/auth/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/transactions/': {
      id: '/dashboard/transactions/'
      path: '/transactions'
      fullPath: '/dashboard/transactions'
      preLoaderRoute: typeof DashboardTransactionsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/rules/': {
      id: '/dashboard/rules/'
      path: '/rules'
      fullPath: '/dashboard/rules'
      preLoaderRoute: typeof DashboardRulesIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/reports/': {
      id: '/dashboard/reports/'
      path: '/reports'
      fullPath: '/dashboard/reports'
      preLoaderRoute: typeof DashboardReportsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/insights/': {
      id: '/dashboard/insights/'
      path: '/insights'
      fullPath: '/dashboard/insights'
      preLoaderRoute: typeof DashboardInsightsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/budgets/': {
      id: '/dashboard/budgets/'
      path: '/budgets'
      fullPath: '/dashboard/budgets'
      preLoaderRoute: typeof DashboardBudgetsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/accounts/': {
      id: '/dashboard/accounts/'
      path: '/accounts'
      fullPath: '/dashboard/accounts'
      preLoaderRoute: typeof DashboardAccountsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/transactions/$id': {
      id: '/dashboard/transactions/$id'
      path: '/transactions/$id'
      fullPath: '/dashboard/transactions/$id'
      preLoaderRoute: typeof DashboardTransactionsIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/reports/$reportId': {
      id: '/dashboard/reports/$reportId'
      path: '/reports/$reportId'
      fullPath: '/dashboard/reports/$reportId'
      preLoaderRoute: typeof DashboardReportsReportIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/categories/$categoryId': {
      id: '/dashboard/categories/$categoryId'
      path: '/categories/$categoryId'
      fullPath: '/dashboard/categories/$categoryId'
      preLoaderRoute: typeof DashboardCategoriesCategoryIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
  }
}

interface DashboardRouteRouteChildren {
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardCategoriesCategoryIdRoute: typeof DashboardCategoriesCategoryIdRoute
  DashboardReportsReportIdRoute: typeof DashboardReportsReportIdRoute
  DashboardTransactionsIdRoute: typeof DashboardTransactionsIdRoute
  DashboardAccountsIndexRoute: typeof DashboardAccountsIndexRoute
  DashboardBudgetsIndexRoute: typeof DashboardBudgetsIndexRoute
  DashboardInsightsIndexRoute: typeof DashboardInsightsIndexRoute
  DashboardReportsIndexRoute: typeof DashboardReportsIndexRoute
  DashboardRulesIndexRoute: typeof DashboardRulesIndexRoute
  DashboardTransactionsIndexRoute: typeof DashboardTransactionsIndexRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardCategoriesCategoryIdRoute: DashboardCategoriesCategoryIdRoute,
  DashboardReportsReportIdRoute: DashboardReportsReportIdRoute,
  DashboardTransactionsIdRoute: DashboardTransactionsIdRoute,
  DashboardAccountsIndexRoute: DashboardAccountsIndexRoute,
  DashboardBudgetsIndexRoute: DashboardBudgetsIndexRoute,
  DashboardInsightsIndexRoute: DashboardInsightsIndexRoute,
  DashboardReportsIndexRoute: DashboardReportsIndexRoute,
  DashboardRulesIndexRoute: DashboardRulesIndexRoute,
  DashboardTransactionsIndexRoute: DashboardTransactionsIndexRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRoute,
  AboutRoute: AboutRoute,
  GocardlessCallbackRoute: GocardlessCallbackRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthSigninRoute: AuthSigninRoute,
  AuthIndexRoute: AuthIndexRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
